<template lang="pug">
div
	div(:loading="$apollo.loading")
		highcharts(v-if="chartOptions", :options="chartOptions", ref="linechart")
</template>

<script>
import Vue from "vue";
import gql from "graphql-tag";
import Highcharts from "highcharts";
import HighchartsVue from 'highcharts-vue'
import moment from "moment";

Vue.use(HighchartsVue, {
	highcharts: Highcharts
})

export default {
	name: "ApprovedSchoolCount",
	props: ["companyId"],
	data() {
		return {
			chartOptions: null
		}	
	},
	watch: {
      CompanyMetabase: function(val) {
          if (val) {
			  const xAxisCategories = val.rows.map(row => {
				return moment(row.identity).format('MMM D, Y');
			  });
			  const series = val.rows.map(row => {
				return row.count;
			  });
			  this.chartOptions = {
				chart: { 
					type: "line",
					width: 1500
				},
				title: {  text: "Approved School Count"  },
				xAxis: {
					categories: xAxisCategories,
					labels: {
						step: 30
					}
				},
				yAxis: {
					title: { text: "Count" },
				}, 
				series: [
					{   
						name: "Approved School Count",
						data: series 
					}
				]
				
			}	
          }
      }
  	},
	apollo: {
		CompanyMetabase: {
			query: gql`
				query CompanyMetabase($company_id: String!, $card_id: Int!) {
					CompanyMetabase(company_id: $company_id, card_id: $card_id) {
						columns {
							identity
							count
						}
						cols {
							name
						}
						rows {
							identity
							count
						}
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			variables() {
				return {
					company_id: this.companyId,
					card_id: 70
				};
			},
			update: r => r.CompanyMetabase
		}
	}
};
</script>
